/* MYCOVAL ™ — tous les CTA ramènent au sélecteur de quantité de la fiche produit */
(function () {
  'use strict';

  var TARGETS = [
    '#myc-offre',
    '.nhb-bundles',
    '.quantity-breaks-container',
    '.quantity-breaks',
    'product-info .product__info-wrapper',
    '.product__info-container',
    '[id$="__main"]'
  ];

  function headerOffset() {
    var h = document.querySelector('.section-header, header.header, sticky-header, #shopify-section-header');
    if (!h) return 12;
    var r = h.getBoundingClientRect();
    // L'en-tête collant de ce thème annonce parfois une hauteur absurde : on borne.
    var v = r.height;
    if (!v || v > 200) v = 90;
    return v + 12;
  }

  function findTarget() {
    for (var i = 0; i < TARGETS.length; i++) {
      var el = document.querySelector(TARGETS[i]);
      if (el && el.getBoundingClientRect().height >= 0) return el;
    }
    return null;
  }

  function scrollToOffer() {
    var el = findTarget();
    if (!el) return;
    var go = function (behavior) {
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: behavior });
    };
    go('smooth');
    // Repli instantané si le défilement doux est bloqué (aperçu, reduced-motion…)
    var before = window.pageYOffset;
    window.setTimeout(function () {
      if (Math.abs(window.pageYOffset - before) < 4) go('auto');
    }, 320);
  }

  window.mycScrollToOffer = scrollToOffer;

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-myc-scroll]') : null;
    if (!t) return;
    e.preventDefault();
    scrollToOffer();
  });
})();
